import { decode } from 'jsonwebtoken-esm';
import authorization from 'services/config/authorization';
import { doorClient, ImResponse, resolve, storeHomeNVClient, storeHomeV2Client } from '.';
import { list } from './assistant.account';
import { stringify } from 'query-string';

export interface OrderOverviewRes {
  orderOutline?: {
    orderCount: number;
    orderAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    paidRate: number;
    cancelOrReturnRate: number;
    reorderRate: number;
    cancelOrReturnCount: number;
    reorderCount: number;
    paidCount: number;
  };
  orderProfit?: {
    codOrderProfits: {
      orderCount: number;
      returnCount: number;
      cancelCount: number;
      rejectCount: number;
      date: string;
    }[];
    noCodOrderProfits: {
      orderCount: number;
      returnCount: number;
      cancelCount: number;
      rejectCount: number;
      date: string;
    }[];
  };
  makingOrderData?: {
    orderCount: number;
    orderMakingAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    noCodMakingCount: number;
    codMakingCount: number;
    makingOrderDataOfDays: {
      makingOrderDataInfo: {
        codMakingCount: number;
        noCodMakingCount: number;
        codMakingOrderAmount?: {
          currencyToAmount: Dashboard.CurrencyToAmount;
        };
        noCodMakingOrderAmount?: {
          currencyToAmount: Dashboard.CurrencyToAmount;
        };
      };
      date: string;
    }[];
  };
  silenceOrderData?: {
    orderCount: number;
    orderAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    silenceOrderCount: number;
    noSilenceOrderCount: number;
    silenceOrderDataOfDays: {
      orderCountSilence: number;
      orderCountNotSilence: number;
      orderSilenceAmount?: {
        currencyToAmount: Dashboard.CurrencyToAmount;
      };
      orderNotSilenceAmount?: {
        currencyToAmount: Dashboard.CurrencyToAmount;
      };
      date: string;
    }[];
  };
  chargebackInfo?: {
    chargebackDataOfDays: {
      returnCount: number;
      cancelCount: number;
      date: string;
    }[];
  };
  reorderInfo?: {
    reorderDataOfDays: {
      orderCount: number;
      reorderCount: number;
      reorderRate: number;
      date: string;
    }[];
  };
  payOrderData?: {
    orderCount: number;
    paidOrderCodCount: number;
    paidOrderNoCodCount: number;
    paidOrderAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    orderPaidDataOfDays: {
      date: string;

      orderPayDate: {
        codPayCount: number;
        noCodPayCount: number;
        codPayAmount?: {
          currencyToAmount: Dashboard.CurrencyToAmount;
        };
        noCodPayAmount?: {
          currencyToAmount: Dashboard.CurrencyToAmount;
        };
      };
    }[];
  };
}

interface SaleConvertConsultType {
  consultBuyerCount: number;
  consultBuyerIsConvertCount: number;
  consultRate: number;
  consultConvertOrderCount: number;
  consultConvertOrderAmount?: {
    currencyToAmount: Dashboard.CurrencyToAmount;
  };
  consultDataOfDays: {
    consultBuyerIsConvertCount: number;
    consultBuyerCount: number;
    consultRate: number;
    date: string;
  }[];
  overallBeatRatio: number;
}

export interface SaleConvertRes {
  consult: SaleConvertConsultType;
  preConsult: SaleConvertConsultType;
  orderReminder: {
    orderReminderBuyerCount: number;
    orderReminderBuyerIsConvertCount: number;
    orderReminderRate: number;
    orderReminderConvertCount: number;
    orderReminderConvertAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    orderReminderOfDays: {
      orderReminderBuyerCount: number;
      orderReminderBuyerIsConvertCount: number;
      orderReminderRate: number;
      date: string;
    }[];
    overallBeatRatio: number;
  };
  paymentReminder: {
    paymentReminderTradeCount: number;
    paymentReminderTradeSuccessCount: number;
    paymentReminderTradeRate: number;
    paymentReminderTradeIsConvertAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    paymentReminderOfDays: {
      paymentReminderTradeCount: number;
      paymentReminderTradeSuccessCount: number;
      paymentReminderTradeRate: number;
      date: string;
    }[];
    overallBeatRatio: number;
  };
  purchaseReminder: {
    purchaseReminderBuyerCount: number;
    purchaseReminderConvertBuyerCount: number;
    purchaseReminderConvertRate: number;
    purchaseReminderConvertTradeCount: number;
    purchaseReminderConvertTradeAmount?: {
      currencyToAmount: Dashboard.CurrencyToAmount;
    };
    purchaseReminderOfDays: {
      purchaseReminderBuyerCount: number;
      purchaseReminderConvertBuyerCount: number;
      purchaseReminderConvertRate: number;
      date: string;
    }[];
    overallBeatRatio: number;
  };
}

interface OrderWastageBasicStats {
  orderLossCount: number;
  orderRetention: number;
  orderLossRate: number;
  overallBeatRatio: number;
  allOrderCount: number;
  orderRetentionRate: number;
}

export interface OrderWastageRes {
  lazadaOrderLossCod: {
    unpaidToPaidCancelCod: OrderWastageBasicStats;
    paidToPackedCancelCod: OrderWastageBasicStats;
    packedToReadyToShipCancelCod: OrderWastageBasicStats;
    readyToShipToShippedCancelCod: OrderWastageBasicStats;
    shippedToCompletedCancelCod: OrderWastageBasicStats;
    afterCompletedCancelCod: OrderWastageBasicStats;
    noneStatusCancelCod: OrderWastageBasicStats;
  };
  lazadaOrderLossNoCod: {
    unpaidToPaidCancelCod: OrderWastageBasicStats;
    paidToPackedCancelCod: OrderWastageBasicStats;
    packedToReadyToShipCancelCod: OrderWastageBasicStats;
    readyToShipToShippedCancelCod: OrderWastageBasicStats;
    shippedToCompletedCancelCod: OrderWastageBasicStats;
    afterCompletedCancelCod: OrderWastageBasicStats;
    noneStatusCancelCod: OrderWastageBasicStats;
  };
  shopeeOrderLossCod: {
    unpaidToPaidCancelCod: OrderWastageBasicStats;
    paidToReadyToShipCancelCod: OrderWastageBasicStats;
    readyToShipToShippedCancelCod: OrderWastageBasicStats;
    shippedToCompletedCancelCod: OrderWastageBasicStats;
    afterCompletedCancelCod: OrderWastageBasicStats;
    noneStatusCancelCod: OrderWastageBasicStats;
  };
  shopeeOrderLossNoCod: {
    unpaidToPaidCancelCod: OrderWastageBasicStats;
    paidToReadyToShipCancelCod: OrderWastageBasicStats;
    readyToShipToShippedCancelCod: OrderWastageBasicStats;
    shippedToCompletedCancelCod: OrderWastageBasicStats;
    afterCompletedCancelCod: OrderWastageBasicStats;
    noneStatusCancelCod: OrderWastageBasicStats;
  };
}

export interface ReviewRes {
  buyerComment?: {
    goodCommentCount: number;
    badCommentCount: number;
    overallBeatRatio: number;
  };
  replyComment?: {
    assistantReplyCommentCount: number;
    botReplyCommentCount: number;
  };
  praiseReminder?: {
    praiseReminderTradeCount: number;
    praiseReminderTradeIsConvertCount: number;
    overallBeatRatio: number;
  };
  fixCommentReminder?: {
    fixCommentReminderTradeCount: number;
    fixCommentReminderGotReplyCount: number;
    fixCommentReminderGotReplyAndGoodCommentCount: number;
    overallBeatRatio: number;
  };
}

export interface StoreInfo {
  id: string;
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  storeType: 'LOCAL' | 'CROSS';
  storeName: string;
  storeNameAlias: string;
}

export interface StatisticsOrderLossRecoveryOfDay {
  orderLossCount: number;
  orderLossCancelledCount: number;
  orderLossReorderCount: number;
  date: string;
  orderBackRate: number;
}

export type RefundType = '仅退款/退货退款' | '退货/退款' | '仅退款' | '取消订单';

export interface DataTableOrderLossRecoveryOfReason {
  refundType: RefundType;
  reason: string;
  orderLossCount: number;
  orderLossRate: number;
  orderLossCancelledCount: number;
  orderLossReorderCount: number;
  orderRecoveryRate: number;
  overallBeatRatio: number;
}

export interface PerfAmount {
  currencyToAmount: Dashboard.CurrencyToAmount;
}

export interface AssistantPerfRes {
  /**
   * 客服id
   */
  assistantId: number;
  /**
   * 帐号昵称
   */
  assistantName: string;
  /**
   * 中差评评价介入平均响应时长
   */
  avgBadCommentRspTimeGap: number;
  /**
   * 取消订单介入平均响应时长
   */
  avgCancelOrderRspTimeGap: number;
  /**
   * 仅退款订单介入平均响应时长
   */
  avgOnlyRefundOrderRspTimeGap: number;
  /**
   * 退货退款订单介入平均响应时长
   */
  avgReturnOrderRspTimeGap: number;
  /**
   * 买家咨询平均等待接待时长
   */
  avgRspTimeMin: number;
  /**
   * 人工客服接待平均响应时长
   */
  avgRspLoginEventTimeMin: number;
  /**
   * 未完成接待买家数
   */
  badConversationCount: number;
  /**
   * 完成接待买家数
   */
  completeRspConversationCount: number;
  /**
   * 需要接待买家数
   */
  conversationCount: number;
  /**
   * 人工客服完成接待买家数
   */
  goodConversationCount: number;
  /**
   * 人工回评数（中差评)
   */
  handleBadCommentCount: number;
  /**
   * 人工操作取消订单数
   */
  handleCancelOrderCount: number;
  /**
   * 人工回评总数
   */
  handleCommentCount: number;
  /**
   * 人工操作仅退款订单数
   */
  handleOnlyRefundOrderCount: number;
  /**
   * 人工操作退货退款订单申请数
   */
  handleReturnOrderCount: number;
  /**
   * 机器人客服或主管完成接待买家数
   */
  mediumConversationCount: number;
  /**
   * 需要人工客服接待买家数
   */
  needAssRspConversationCount: number;
  /**
   * 人工参与接待买家数
   */
  asstPartReceptionCount: number;
  /**
   * 账户在线总时长(分钟)
   */
  onlineMin: number;
  /**
   * 整体买家接待后下单转化率
   */
  overallOrderConvertRatio: number;
  /**
   * 整体买家接待后付款转化率
   */
  overallPayOrderConvertRatio: number;
  /**
   * 接待完成率
   */
  overallResponseRate: number;
  /**
   * 人工客服接待完成率
   */
  participateResponseRate: number;
  /**
   * 需要接待的售前买家数
   */
  preSaleConversationCount: number;
  /**
   * 售前买家接待后下单转化率
   */
  preSaleOrderConvertRatio: number;
  /**
   * 售前买家接待后付款转化率
   */
  preSalePayOrderConvertRatio: number;
  /**
   * 售前买家接待后下单买家数
   */
  preSaleRspOrderBuyerCount: number;
  /**
   * 售前买家接待后下单订单数
   */
  preSaleRspOrderCount: number;
  /**
   * 售前买家接待后下单订单金额
   */
  preSaleRspOrderTradeAmount?: PerfAmount;
  /**
   * 售前买家接待后付款买家数
   */
  preSaleRspPayOrderBuyerCount: number;
  /**
   * 售前买家接待后付款订单数
   */
  preSaleRspPayOrderCount: number;
  /**
   * 售前买家接待后付款订单金额
   */
  preSaleRspPayOrderTradeAmount?: PerfAmount;
  /**
   * 重要提醒解决平均耗时
   */
  remindRecordElapsedTime: number;
  /**
   * 中差评订单挽回率
   */
  rspBadCommentConvertRatio: number;
  /**
   * 中差评订单挽回率30天
   */
  rspBadCommentConvertRatioThirtyDays: number;
  /**
   * 人工客服对中差评发起的沟通数
   */
  rspBadCommentCount: number;
  /**
   * 介入后中差评修改为好评的评价数
   */
  rspBadCommentIsRecoveredCount: number;
  /**
   * 取消订单挽回率
   */
  rspCancelOrderConvertRatio: number;
  /**
   * 人工对取消订单发起的沟通数
   */
  rspCancelOrderCount: number;
  /**
   * 介入后撤销的取消订单数
   */
  rspCancelOrderIsCancelledCount: number;
  /**
   * 介入后撤销的取消订单金额
   */
  rspCancelOrderIsCancelledTradeAmount?: PerfAmount;
  /**
   * 介入后挽回的取消订单数
   */
  rspCancelOrderIsRecoveredCount: number;
  /**
   * 介入后再下单的取消订单数
   */
  rspCancelOrderIsReorderCount: number;
  /**
   * 介入后取消订单再下单的订单金额
   */
  rspCancelOrderIsReorderToTradeAmount?: PerfAmount;
  /**
   * 介入后取消订单再下单的订单数
   */
  rspCancelOrderIsReorderToTradeCount: number;
  /**
   * 仅退款订单挽回率
   */
  rspOnlyRefundOrderConvertRatio: number;
  /**
   * 人工对仅退款订单发起的沟通数
   */
  rspOnlyRefundOrderCount: number;
  /**
   * 介入后撤销的仅退款订单数
   */
  rspOnlyRefundOrderIsCancelledCount: number;
  /**
   * 介入后撤销的仅退款订单金额
   */
  rspOnlyRefundOrderIsCancelledTradeAmount?: PerfAmount;
  /**
   * 介入后挽回的仅退款订单数
   */
  rspOnlyRefundOrderIsRecoveredCount: number;
  /**
   * 介入后再下单的仅退款订单数
   */
  rspOnlyRefundOrderIsReorderCount: number;
  /**
   * 介入后仅退款订单再下单的订单金额
   */
  rspOnlyRefundOrderIsReorderToTradeAmount?: PerfAmount;
  /**
   * 介入后仅退款订单再下单的订单数
   */
  rspOnlyRefundOrderIsReorderToTradeCount: number;
  /**
   * 整体买家接待后下单买家数
   */
  rspOrderBuyerCount: number;
  /**
   * 整体买家接待后下单订单数
   */
  rspOrderCount: number;
  /**
   * 整体买家接待后下单订单金额
   */
  rspOrderTradeAmount?: PerfAmount;
  /**
   * 整体买家接待后付款买家数
   */
  rspPayOrderBuyerCount: number;
  /**
   * 整体买家接待后付款订单数
   */
  rspPayOrderCount: number;
  /**
   * 整体买家接待后付款订单金额
   */
  rspPayOrderTradeAmount?: PerfAmount;
  /**
   * 已解决重要提醒买家数
   */
  rspRemindRecoderCount: number;
  /**
   * 退货退款订单挽回率
   */
  rspReturnOrderConvertRatio: number;
  /**
   * 人工对退货退款订单发起的沟通数
   */
  rspReturnOrderCount: number;
  /**
   * 介入后撤销的退货退款订单数
   */
  rspReturnOrderIsCancelledCount: number;
  /**
   * 介入后撤销的退货退款订单金额
   */
  rspReturnOrderIsCancelledTradeAmount?: PerfAmount;
  /**
   * 介入后挽回的退货退款订单数
   */
  rspReturnOrderIsRecoveredCount: number;
  /**
   * 介入后再下单的退货退款订单数
   */
  rspReturnOrderIsReorderCount: number;
  /**
   * 介入后退货退款订单再下单的订单金额
   */
  rspReturnOrderIsReorderToTradeAmount?: PerfAmount;
  /**
   * 介入后退货退款订单再下单的订单数
   */
  rspReturnOrderIsReorderToTradeCount: number;
  /**
   * 人工参与接待后的中差评评价数
   */
  asstGenBadCommentCount: number;
  /**
   * 人工参与接待后有评价内容的中差评评价数
   */
  asstGenBadCommentWithContentCount: number;
  /**
   * 介入后中差评修改为好评的评价数30天
   */
  rspBadCommentIsRecoveredCountThirtyDays: number;
  /**
   * 人工客服有接待权限店铺的中差评评价数
   */
  asstStoreBadCommentCount: number;
  /**
   * 人工参与接待后的中差评率
   */
  asstGenBadCommentRatio: number;
  /**
   * 人工参与接待后有评价内容的中差评率
   */
  asstGenBadCommentWithContentRatio: number;
  /**
   * 人工最后一次下线时待处理买家数
   */
  untreatedCount: number;
  /**
   * 人工x分钟内响应率
   */
  asstRspTimeIn1MinRatio: number;
  asstRspTimeIn5MinRatio: number;
  asstRspTimeIn10MinRatio: number;
  asstRspTimeIn15MinRatio: number;
  asstRspTimeIn30MinRatio: number;
  asstRspTimeIn60MinRatio: number;
  /**
   * 买家咨询x分钟内被接待率
   */
  asstBuyerWaitTime1MinRatio: number;
  asstBuyerWaitTime5MinRatio: number;
  asstBuyerWaitTime10MinRatio: number;
  asstBuyerWaitTime15MinRatio: number;
  asstBuyerWaitTime30MinRatio: number;
  asstBuyerWaitTime60MinRatio: number;
  /**
   * 人工参与接待买家数（仅售前买家）
   */
  asstPartReceptionCountPreSale: number;
  /**
   * 账号挂起总时长(分钟)
   */
  hangMin: number;
  /**
   * 人工接待后平均关闭会话时长
   */
  avgHandlingTime: number;
  /**
   * 人工平均关闭会话时长
   */
  avgFullResolutionTime: number;
  /**
   * 提交知识数量--提交知识数
   */
  submittedCount: number;
  /**
   * 启用知识数量--启用的知识数
   */
  enabledCount: number;
  /**
   * 自学习回复问题数--贡献的AI回复数
   */
  aiLearningReplyCount: number;
  /**
   * 启用率--知识采纳率
   */
  enabledRate: number;
  /**
   * 提交率--知识提交率
   */
  submittedRate: number;
}

export interface RobotContributionOverviewRes {
  conversationReplyCount: number;
  reminderOrderCount: number;
  reminderPaymentCount: number;
  cancelOrderReminderCount: number;
  praiseReminderCount: number;
  autoReviewCount: number;
}

export interface RobotReceptionRes {
  conversationCount: number;
  replyConversationCount: number;
  replyRate: number;
  buyerQuestionCount: number;
  replyQuestionCount: number;
  replyBuyerIsConvertCount: number;
  consultConvertRate: number;
  replyBuyerIsConvertTradeCount: number;
  avgRspTimeSecond: number;
  avgCommunicateCount: number;
  rspTimeSecondTotal: number;
  communicateTotal: number;
  count: number;
  date: string;
}

export interface RobotReminderOrderOfDay {
  date: string;
  orderReminderDispatchCount: number;
  orderReminderBuyerCount: number;
  orderReminderIsConvertCount: number;
  orderReminderRate: number;
  orderReminderIsConvertTradeCount: number;
  orderReminderIsConvertTradeAmount: {
    currencyToAmount: Dashboard.CurrencyToAmount;
  };
}

export interface RobotPaymentReminderOfDay {
  date: string;
  paymentReminderDispatchCount: number;
  paymentReminderOrderCount: number;
  paymentReminderIsConvertCount: number;
  paymentReminderRate: number;
  paymentReminderIsConvertTradeAmount: {
    currencyToAmount: Dashboard.CurrencyToAmount;
  };
  paymentReminderIsConvertTradeAmountCny: number;
}

export interface RobotCancelOrderReminderOfDay {
  date: string;
  cancelOrderReminderDispatchCount: number;
  cancelOrderReminderOrderCount: number;
  cancelOrderReminderIsConvertCount: number;
  cancelOrderRate: number;
}

export interface RobotPraiseReminderOfDay {
  date: string;
  praiseReminderDispatchCount: number;
  praiseReminderOrderCount: number;
  praiseReminderIsConvertCount: number;
  praiseReminderRate: number;
}

export interface RobotAutoReviewOfDay {
  date: string;
  commentCreateCount: number;
  fiveStarCommentCreateCount: number;
  fourStarCommentCreateCount: number;
  botHandleCommentCount: number;
  fiveStarBotHandleCommentCount: number;
  fourStarBotHandleCommentCount: number;
  autoReviewRate: number;
  fiveStarAutoReviewRate: number;
  fourStarAutoReviewRate: number;
}

export interface RobotReminderOrderRes {
  rate: number;
  reminderOrderOfDays: RobotReminderOrderOfDay[];
}

export interface RobotPaymentReminderRes {
  rate: number;
  robotPaymentReminderOfDays: RobotPaymentReminderOfDay[];
}

export interface RobotCancelOrderReminderRes {
  rate: number;
  cancelOrderReminderOfDays: RobotCancelOrderReminderOfDay[];
}

export interface RobotPraiseReminderRes {
  rate: number;
  robotPraiseReminderOfDays: RobotPraiseReminderOfDay[];
}

export interface RobotAutoReviewRes {
  rate: number;
  autoReviewOfDays: RobotAutoReviewOfDay[];
}

const getOrgIdAndUserId = () => {
  const key = authorization.cacheKey || '';
  const token = authorization.storage?.getItem(key) || '';
  const payload: any = decode(token, { json: true });
  return { orgId: payload?.orgId, userId: payload?.id };
};

const getHeaderLang = (lang: General.SystemLanguage) =>
  lang === 'en-US' ? 'en_US' : lang === 'zh-CN' ? 'zh_CN' : lang;

export type DashboardType =
  | 'order'
  | 'performance'
  | 'product_groups'
  | 'store_performance'
  | 'todo'; //product_groups为商品组场景适用，非dashboard场景

export function getDepartmentList(dashboardType: DashboardType) {
  return resolve(
    storeHomeV2Client.get<ImResponse<{ departments: Dashboard.Department[] }>>(
      '/admin/user/dashboard_departments',
      { params: { dashboardType } },
    ),
  );
}

export type Scene =
  | 'ORDER_STAT'
  | 'ASSISTANT_PERFORMANCE'
  | 'VIEW_PLATFORM_DATA'
  | 'EXPORT_PLATFORM_DATA';

export function getStoreList(params: {
  platforms?: General.PlatformUpperCase[];
  regions?: General.CaselessRegion[];
  storeTypes?: IM_API.Admin.StoreType;
  departmentId?: number;
  departmentIds?: number[];
  scene: Scene;
}) {
  return resolve(
    storeHomeNVClient.get<ImResponse<{ storeInfos: StoreInfo[] }>>('/dashboard/get_store_info', {
      params: {
        platforms: params.platforms?.toString(),
        regions: params.regions?.toString(),
        storeTypes: params.storeTypes,
        departmentId: params.departmentId,
        departmentIds: params.departmentIds,
        scene: params.scene,
      },
    }),
  );
}

export function getOrderOverview(params: Dashboard.BasicParams): Promise<OrderOverviewRes> {
  return resolve(
    storeHomeNVClient.post<ImResponse<OrderOverviewRes>>(
      '/api_gateway/dashboard/performance/order/overview',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function exportOrderOverview({ lang, currency, ...params }: Dashboard.ExportParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/performance/order/overview/export',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(lang),
          currency,
        },
      },
    ),
  );
}

export interface IndustryRankResponse {
  overallBeatRatio: number;
  performanceName: string;
  rankOfSections: RankOfSection[];
}

export interface RankOfSection {
  dailyRankOfSections: DailyRankOfSection[];
  section: Section;
  /**
   * 该行业是否参与排名
   */
  visible: boolean;
  /**
   * 当前行业的击败率
   */
  beatRatio: number;
}

export interface DailyRankOfSection {
  beatRatio: number;
  date: string;
  selfPerformance: number;
  selfPerformanceDenominator: number;
  selfPerformanceNumerator: number;
  top10: number;
  top25: number;
  top5: number;
  top50: number;
}

type AllPlatform = General.PlatformUpperCase | '所有平台';
type AllStoreType = Exclude<Dashboard.BasicParams['storeType'], undefined> | '所有类型';
type AllRegion = General.Region | '所有地区';

export interface Section {
  platform: AllPlatform;
  storeType: AllStoreType;
  region: AllRegion;
  domain: Util.PickByType<string, string>;
}

export type PerformanceName =
  // 订单概况页面
  | 'REORDER_RATIO' // 复购率
  // 销售转化页面
  | 'PRE_SALE_CONSULT_CONVERSION_RATE' // 售前咨询转化率
  | 'OVERALL_CONSULT_CONVERSION_RATE' // 整体咨询转化率
  | 'ORDER_REMINDER_CONVERSION_RATE' // 催单后下单买家比例
  | 'PAYMENT_REMINDER_CONVERSION_RATE' // 催付款后付款比例

  // 非COD订单损耗
  | 'NOT_COD_OVERALL_LOSS_RATE' // 非COD订单整体损耗率
  | 'NOT_COD_ORDER_TO_PAYMENT_LOSS_RATE' // 非COD订单损耗：下单-付款-损耗率
  | 'NOT_COD_PAYMENT_TO_READY_TO_SHIP_LOSS_RATE' // 非COD订单损耗：付款-卖家点击发货-损耗率（shopee）
  | 'NOT_COD_PAYMENT_TO_PACKED_LOSS_RATE' // 非COD订单损耗：付款-打包-损耗率（lazada）
  | 'NOT_COD_PACKED_TO_READY_TO_SHIP_LOSS_RATE' // 非COD订单损耗：打包-卖家点击发货-损耗率（lazada）
  | 'NOT_COD_READY_TO_SHIP_TO_SHIPPED_LOSS_RATE' // 非COD订单损耗：卖家点击发货-揽收-损耗率
  | 'NOT_COD_SHIPPED_TO_RECEIVED_LOSS_RATE' // 非COD订单损耗：揽收-买家收货-损耗率
  | 'NOT_COD_RECEIVED_TO_CLOSED_LOSS_RATE' // 非COD订单损耗：买家收货-订单结束-损耗率

  // COD订单损耗
  | 'COD_OVERALL_LOSS_RATE' // COD订单损耗：损耗率
  | 'COD_ORDER_TO_CONFIRMED_LOSS_RATE' // COD订单损耗：下单-订单确认-损耗率
  | 'COD_CONFIRMED_TO_READY_TO_SHIP_LOSS_RATE' // COD订单损耗：订单确认-卖家点击发货-损耗率（shopee）
  | 'COD_CONFIRMED_TO_PACKED_LOSS_RATE' // COD订单损耗：订单确认-打包-损耗率（lazada）
  | 'COD_PACKED_TO_READY_TO_SHIP_LOSS_RATE' // COD订单损耗：打包-卖家点击发货-损耗率（lazada）
  | 'COD_READY_TO_SHIP_TO_SHIPPED_LOSS_RATE' // COD订单损耗：卖家点击发货-揽收-损耗率
  | 'COD_SHIPPED_TO_RECEIVED_LOSS_RATE' // COD订单损耗：揽收-买家收货-损耗率
  | 'COD_RECEIVED_TO_CLOSED_LOSS_RATE' // COD订单损耗：买家收货-订单结束-损耗率

  // 评价数据页面
  | 'BAD_COMMENT_RATE' // 买家评价：中差评率
  | 'PRAISE_REMINDER_CONVERSION_RATE' // 自动催好评：自动催好评成功率
  | 'FIX_COMMENT_REMINDER_CONVERSION_RATE'; // 中差评挽回：中差评挽回率
export interface IndustryRankRequest extends Dashboard.BasicParams {
  //  指标名称
  performanceName: PerformanceName;
  // 区域
  regions?: General.UpperCaseRegion[];
  departmentId: number;
}

export interface RecoverRankRequest extends Dashboard.BasicParams {
  cancelType: RefundType;
  reason: string;
  /**
   * 0  不是cod
   * 1  cod
   */
  isCod: 0 | 1;
  departmentId: number;
  // 区域
  regions?: General.UpperCaseRegion[];
}

export interface RecoverRankResponse {
  cancelType: RefundType;
  overallBeatRatio: number;
  rankOfSections: RankOfSection[];
  reason: string;
}

/**
 * 获取行业排名与水平指标
 * @param params
 * @returns
 */
export function getIndustryRank(params: Partial<IndustryRankRequest>) {
  return resolve(
    storeHomeNVClient.post<ImResponse<IndustryRankResponse>>(
      '/api_gateway/dashboard/performance/rank',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

/**
 * 获取订单挽回原因行业排名与水平
 * @param params
 * @returns
 */
export function getRecoverRank(params: Partial<RecoverRankRequest>): Promise<RecoverRankResponse> {
  return resolve(
    storeHomeNVClient.post<ImResponse<RecoverRankResponse>>(
      '/api_gateway/dashboard/performance/rank/order/recovery',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getSaleConvert(params: Dashboard.BasicParams): Promise<SaleConvertRes> {
  return resolve(
    storeHomeNVClient.post<ImResponse<SaleConvertRes>>(
      '/api_gateway/dashboard/performance/sales/convert',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function exportSaleConvert({ lang, currency, ...params }: Dashboard.ExportParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/performance/sales/convert/export',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(lang),
          currency,
        },
      },
    ),
  );
}

export function getOrderWastage(params: Dashboard.BasicParams): Promise<OrderWastageRes> {
  return resolve(
    storeHomeNVClient.post('/api_gateway/dashboard/performance/order/loss', {
      ...params,
      ...getOrgIdAndUserId(),
    }),
  );
}

export function exportOrderWastage({ lang, currency, ...params }: Dashboard.ExportParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/performance/order/loss/export',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(lang),
          currency,
        },
      },
    ),
  );
}

export function getNoCODOrderWastageRecover(params: Dashboard.GetNonCodWastageRecoverParams) {
  return resolve(
    storeHomeNVClient.post<
      ImResponse<{
        statisticsOrderLossRecoveryOfDays: StatisticsOrderLossRecoveryOfDay[];
        dataTableOrderLossRecoveryOfReason: DataTableOrderLossRecoveryOfReason[];
      }>
    >('/api_gateway/dashboard/performance/order/recovery', {
      ...params,
      ...getOrgIdAndUserId(),
    }),
  );
}

export type WastageReason = Dashboard.WastageReason;

export function getReason(params: Dashboard.WastageParams) {
  return resolve(
    storeHomeNVClient.post<
      ImResponse<{
        reasonDataList: WastageReason[];
      }>
    >('/api_gateway/dashboard/performance/order/reasons', {
      ...params,
      ...getOrgIdAndUserId(),
    }),
  );
}

export function getReview(params: Dashboard.BasicParams): Promise<ReviewRes> {
  return resolve(
    storeHomeNVClient.post<ImResponse<ReviewRes>>('/api_gateway/dashboard/performance/comment', {
      ...params,
      ...getOrgIdAndUserId(),
    }),
  );
}

export function exportReview({ lang, currency, ...params }: Dashboard.ExportParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/performance/comment/export',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(lang),
          currency,
        },
      },
    ),
  );
}

export function downloadReason(
  params: Dashboard.WastageParams & {
    language: General.SystemLanguage;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      'api_gateway/dashboard/performance/order/recovery/export',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export const getAssistantIds = (assistantIds: string[] = [], departmentIds: number[] = []) => {
  return (
    assistantIds.length === 0 && departmentIds.length > 0
      ? list({
          page: 1,
          pageSize: 1000,
          departmentIds,
        }).then((res) => (res.data || []).map((_) => _.id))
      : Promise.resolve(assistantIds)
  ).then((assistantIds) => (assistantIds.length === 0 ? undefined : assistantIds));
};

// 客服绩效报告
export function getAssistantPerfReport(params: Dashboard.AssistantPerfParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<{ assistantPerformances: AssistantPerfRes[] }>>(
      'api_gateway/dashboard/assistant/performance/v3',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

// 客服绩效报告总计
export function getAssistantPerfReportSum(params: Dashboard.AssistantPerfParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<{ assistantPerformances: AssistantPerfRes[] }>>(
      'api_gateway/dashboard/assistant/performance/v3/sum',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

// 客服绩效报告总计平均值
export function getAssistantPerfReportAvg(params: Dashboard.AssistantPerfParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<{ assistantPerformances: AssistantPerfRes[] }>>(
      'api_gateway/dashboard/assistant/performance/v3/avg',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function assistantAuth() {
  return resolve(
    storeHomeNVClient.post<ImResponse<boolean>>('/api_gateway/dashboard/assistant/auth', {
      ...getOrgIdAndUserId(),
    }),
  );
}

export function downloadAssistantPerf({
  language: lang,
  ...params
}: Dashboard.AssistantPerfParams & {
  currency?: Dashboard.CurrencyShorthand;
  language: General.SystemLanguage;
  indexes?: string[];
  sheets: string[];
}) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/assistant/export/performance/v4',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(lang),
        },
      },
    ),
  );
}

export function downloadSingleAssistantPerf(
  params: Dashboard.AssistantPerfParams & {
    currency?: Dashboard.CurrencyShorthand;
    language?: General.SystemLanguage;
    sheets: string[];
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      '/api_gateway/dashboard/assistant/export/performance/v3/detail',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(params.language || 'zh-CN'),
        },
      },
    ),
  );
}

export function getRobotContributionOverview(
  params: Dashboard.BasicParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotContributionOverviewRes>>(
      'api_gateway/dashboard/robot/contribution/conversation/outline',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getRobotReception(
  params: Dashboard.RobotReceptionParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<{ conversationDataOfDays: RobotReceptionRes[] }>>(
      'api_gateway/dashboard/robot/contribution/conversation',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getRobotOrderContribution(
  params: Dashboard.BasicParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotReminderOrderRes>>(
      'api_gateway/dashboard/robot/contribution/order/reminder',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getRobotPaymentContribution(
  params: Dashboard.BasicParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotPaymentReminderRes>>(
      'api_gateway/dashboard/robot/contribution/payment/reminder',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getRobotCancelOrderContribution(
  params: Dashboard.BasicParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotCancelOrderReminderRes>>(
      'api_gateway/dashboard/robot/contribution/cancel/order/reminder',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getRobotCommentContribution(
  params: Dashboard.BasicParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotPraiseReminderRes>>(
      'api_gateway/dashboard/robot/contribution/praise/reminder',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export function getRobotReplyContribution(
  params: Dashboard.BasicParams & {
    // true是问答
    qaIs: boolean;
  },
) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotAutoReviewRes>>(
      'api_gateway/dashboard/robot/contribution/auto/review',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
    ),
  );
}

export type RobotContribution =
  | 'CONVERSATION'
  | 'ORDER_REMINDER'
  | 'PAYMENT_REMINDER'
  | 'CANCEL_ORDER_REMINDER'
  | 'PRAISE_REMINDER';

export function downloadRobotContribution({
  lang,
  ...params
}: Dashboard.BasicParams & {
  // true是问答
  qaIs: boolean;
  robotContributionType: RobotContribution;
  conversationType?: Dashboard.RobotReceptionParams['conversationType'];
  lang: General.SystemLanguage;
}) {
  return resolve(
    storeHomeNVClient.post<ImResponse<string>>(
      'api_gateway/dashboard/robot/contribution/export/robot/contribution',
      {
        ...params,
        ...getOrgIdAndUserId(),
      },
      {
        headers: {
          lang: getHeaderLang(lang),
        },
      },
    ),
  );
}

export type AssitantRealtimeStatus =
  | 'HANGUP'
  | 'OFFLINE'
  | 'ONLINE'
  | 'UNKNOWN_ASSISTANT_ONLINE_STATUS';

export interface OverseaimConversationAssistantRealtimeStats {
  /**
   * 客服id
   */
  id: string;
  /**
   * 昵称
   */
  name: string;
  /**
   * 离线时间
   */
  offlineTimestamp: string;
  /**
   * 上线时间
   */
  onlineTimestamp: string;
  /**
   * 强提醒买家数
   */
  remind: number;
  /** 默认值: UNKNOWN_ASSISTANT_ONLINE_STATUS */
  status: AssitantRealtimeStatus;
  /**
   * 分配买家总数
   */
  totalAssign: number;
  /**
   * 人工回复买家总数
   */
  totalManualReply: number;
  /**
   * 累计在线秒数
   */
  totalOnlineSeconds: number;
  /**
   * 回复买家总数
   */
  totalReply: number;
  /**
   * 待处理买家数
   */
  unprocessed: number;
  /**
   * 离线时客服的待处理买家数
   */
  unprocessedWhenOffline: number;
  /**
   * 排队中买家数
   */
  waitAssign: number;
  /**
   * 累计挂起时长
   */
  totalHangSeconds: number;
  /**
   * 累计挂起次数
   */
  totalHangTimes: number;
  /**
   * 最近挂起时间
   */
  hangTimestamp: string;
  /**
   * 子状态挂起时长
   */
  subStatusDuration: {
    status: AssitantRealtimeStatus;
    subStatus: string;
    seconds: number;
  }[];
  /**
   * 最早待处理会话时间
   */
  minLastBuyerMsgTime: string;
  timeZone: number;
  timeZoneUpdateTime: string;
  negRateAssigned: number;
  cancelOrderAssigned: number;
  paidCount: number;
}

export interface OverseaimConversationGetAssistantRealtimeStatsData {
  nextMinAssistantId: string;
  stats: OverseaimConversationAssistantRealtimeStats[];
}

export interface IGetAssistantRealtimeStats {
  /**
   * 筛选的客服id, 多个时逗号分隔
   */
  assistantIds?: string;
  /**
   * 分页参数，最小的assistant_id，第一页不传，其他页传上一页返回的
   */
  minAssistantId?: string;
  /**
   * 分页参数，每页大小
   */
  pageSize?: number;
}

export function getAssistantRealtimeStats(params: IGetAssistantRealtimeStats) {
  return resolve(
    doorClient.get<ImResponse<OverseaimConversationGetAssistantRealtimeStatsData>>(
      '/aggregation/v1/getAssistantRealtimeStats',
      { params },
    ),
  );
}

export type DashboardName =
  | 'OrderOverview'
  | 'SalesConversion'
  | 'OrderLoss'
  | 'Review'
  | 'PerformanceAgent'
  | 'PerformanceRobot'
  | 'AIReplyRobotReply'
  | 'QaPair';

export interface LatestDateBody {
  dashboardName: DashboardName;
}

export interface LatestDate {
  dashboardName: DashboardName;
  latestDate: string;
}

export function latestDate(body: LatestDateBody) {
  return resolve(
    storeHomeNVClient.post<ImResponse<LatestDate[]>>(
      '/api_gateway/dashboard/performance/date-range',
      body,
    ),
  );
}

export function mercadoReputation(params: { storeIds: number[] }) {
  return storeHomeNVClient.get<
    {
      storeName: string;
      storeAlias: string;
      storeType: 'LOCAL' | 'CROSS';
      region: General.UpperCaseRegion;
      level: `${number}${string}`;
      sellerStatus: 'platinum' | 'gold' | 'silver' | '';
      sales: { value: string; rate: number };
      claims: { value: string; rate: number };
      delayedDandling: { value: string; rate: number };
      cancellations: { value: string; rate: number };
    }[]
  >('/api_gateway/dashboard/mercado/reputation', {
    params,
    paramsSerializer: (params) => stringify(params, { arrayFormat: 'none' }),
  });
}

export interface AmountTotal {
  region: General.UpperCaseRegion;
  unit: string;
  code: string;
  amount: string;
}

export interface ActivityStats {
  dispatchBuyerTotal: number;
  activityTradeTotal: number;
  botTradeBuyerTotal: number;
  botTradeBuyerRate: number;
  botTradeTotal: number;
  activityTradeAmountTotal: number;
  activityTradeAmountTotalList: AmountTotal[];
  botTradeAmountTotal: number;
  botTradeAmountTotalList: AmountTotal[];
}

export interface ActivityStatsWithDaily extends ActivityStats {
  dailyData: {
    dt: string;
    dispatchBuyerCount: number;
    activityTradeCount: number;
    botTradeCount: number;
    activityTradeAmount: number;
    activityTradeAmountList: AmountTotal[];
    botTradeAmount: number;
    botTradeAmountList: AmountTotal[];
    botTradeBuyerRate: number;
  }[];
}

export function activityConversionStats({
  activityId,
  lang,
}: {
  activityId: string | number;
  lang: General.SystemLanguage;
}) {
  return resolve(
    storeHomeNVClient.get<ImResponse<ActivityStatsWithDaily>>(
      '/api_gateway/dashboard/activity_conversion/stats',
      {
        params: { activityId },
        headers: {
          lang: getHeaderLang(lang),
        },
      },
    ),
  );
}

export function activityConversionExport(
  activityId: string | number,
  lang: General.SystemLanguage,
) {
  return storeHomeNVClient.post(
    '/api_gateway/dashboard/activity_conversion/export',
    {
      activityId,
    },
    {
      headers: {
        lang: getHeaderLang(lang),
      },
    },
  );
}

export interface ActivityGlobalStatsBody {
  activityIds: number[];
  startTimeMs: number;
  endTimeMs: number;
}

export interface PlatformRegionData {
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  botTradeCount: number;
  activityTradeCount: number;
  activityTradeAmount: number;
  activityTradeAmountList: AmountTotal[];
  botTradeAmount: number;
  botTradeAmountList: AmountTotal[];
}

export function activityGlobalStats(body: ActivityGlobalStatsBody) {
  return resolve(
    storeHomeNVClient.post<
      ImResponse<
        ActivityStatsWithDaily & {
          platformRegionData: PlatformRegionData[];
        }
      >
    >('/api_gateway/dashboard/activity_conversion/global/stats', body),
  );
}

export function activityGlobalList(
  body: ActivityGlobalStatsBody & {
    pageNo: number;
    pageSize: number;
  },
) {
  return resolve(
    storeHomeNVClient.post<
      ImResponse<{
        total: number;
        pageNo: number;
        details: (Pick<Knowledge.Activity.Detail, 'activityName' | 'activityType'> &
          ActivityStats & {
            activityId: number;
            activityStatus: string;
            region: General.UpperCaseRegion;
            platform: General.PlatformUpperCase;
          })[];
      }>
    >('/api_gateway/dashboard/activity_conversion/global/list', body),
  );
}

export function activityGlobalExport(body: ActivityGlobalStatsBody) {
  return storeHomeNVClient.post('/api_gateway/dashboard/activity_conversion/global/export', body);
}

export interface TrailReport {
  id: number;
  // 咨询问题总数
  queryCount: number;
  // ai回复问题数
  aiReplyQueryCount: number;
  // 回复问题数(人工+ai)
  replyQueryCount: number;
  // 人机结合回复率
  replyRatio: string;
  // ai回复率
  aiReplyRatio: number;
  // 接待买家数
  receptionBuyerCount: number;
  // ai接待买家数
  aiReceptionBuyerCount: number;
  // ai独立接待买家数
  aiAloneReceptionBuyerCount: number;
  // ai接待买家占比
  aiReceptionRatio: number;
  // ai独立接待买家占比
  aiAloneReceptionRatio: number;
  // 使用ai之前的平均响应时长（s）
  beforeRespTime: number;
  // 使用ai之后的平均响应时长（s）
  afterRespTime: number;
  // 使用ai之后平均响应时长减少（s）
  reduceRespTime: number;
  // 使用前5分钟回复率
  beforeFiveMinuteRespRatio: number;
  // 使用后5分钟回复率
  afterFiveMinuteRespRatio: number;
  // 使用后提升了多少
  reduceFiveMinuteRespRatio: number;
  // ai独立接待买家订单数
  aiAloneReceptionBuyerOrderCount: number;
  // ai独立接待买家订单金额
  aiAloneReceptionBuyerOrderAmountList: AmountTotal[];
  unRead: boolean;
  startTime: number;
  endTime: number;
}

/**
 * 获取 AI 回复试用报告
 */
export function getTrailReportList(signal?: AbortSignal) {
  return resolve(
    storeHomeNVClient.get<ImResponse<TrailReport[]>>('/api_gateway/dashboard/trial_report/list', {
      signal,
    }),
  );
}

export interface TrailReportConversation {
  conversationId: number;
  // 定位消息
  fixedMsgId: number;
}

/**
 * 获取 AI 回复报告会话列表
 * @param reportId
 */
export function getTrailReportConversationList(reportId: number) {
  return resolve(
    storeHomeNVClient.get<ImResponse<TrailReportConversation[] | undefined>>(
      '/api_gateway/dashboard/trial_report/conversation/list',
      {
        params: { reportId },
      },
    ),
  );
}

/**
 * AI 回复报告标记已读
 * @param reportId
 */
export function readTrialReport(reportId: number) {
  return resolve(
    storeHomeNVClient.post<ImResponse<undefined>>('/api_gateway/dashboard/trial_report/haveRead', {
      reportId,
    }),
  );
}

export interface RobotContributionMsgReplyRateDay {
  replyRate: number;
  humanReplyRate: number;
  aiReplyRate: number;
  autoReplyRate: number;
  replyTime: number;
  dt: string;
}

export interface RobotContributionMsgReplyConsulDay {
  buyerCount: number;
  queryCount: number;
  replyCount: number;
  dt: string;
}

export interface RobotContributionMsgReplyReplyDetailDay {
  dt: string;
  buyerCount: number;
  queryCount: number;
  replyCount: number;
  aiReplyCount: number;
  autoReplyCount: number;
  humanReplyCount: number;
  replyRate: number;
  humanReplyRate: number;
  aiReplyRate: number;
  autoReplyRate: number;
  replyTime: number;
  aiReplyTime: number;
  autoReplyTime: number;
  humanReplyTime: number;
  replyRate5min: number;
  humanReplyRate5min: number;
  aiReplyRate5min: number;
  autoReplyRate5min: number;
  aiReplyMin5Count: number;
  autoReplyMin5Count: number;
  humanReplyMin5Count: number;
  aiAloneReceptionBuyerCount: number;
  aiAloneReceptionBuyerRate: number;
}

export interface RobotContributionMsgReplyData {
  replyRateDays: RobotContributionMsgReplyRateDay[];
  consulDataDays: RobotContributionMsgReplyConsulDay[];
  replyDetailDays: RobotContributionMsgReplyReplyDetailDay[];
}

export function getRobotContributionMsgReply(body: Dashboard.BasicParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<RobotContributionMsgReplyData>>(
      '/api_gateway/dashboard/robot/contribution/msg/reply',
      {
        ...body,
        qaIs: true,
        robotContributionType: 'CONVERSATION',
      },
    ),
  );
}

export function downloadRobotContributionMsgReply(body: Dashboard.BasicParams) {
  return resolve(
    storeHomeNVClient.post<ImResponse<undefined>>(
      '/api_gateway/dashboard/robot/contribution/msg/reply/export',
      {
        ...body,
        qaIs: true,
        robotContributionType: 'CONVERSATION',
      },
    ),
  );
}
